import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const CustomButton = ({ text, onClick, href, style, type = "blue", fontSize = "12px", margin = "0"}) => {
  const theme = useTheme();

  // Definir estilos según el tipo de botón
  const buttonStyles = {
    blue: {
      backgroundColor: theme.palette.primary.main, // Azul
      color: "white",
    },
    orange: {
      backgroundColor: theme.palette.warning.main, // Naranja
      color: "white",
    },
  };

  return (
    <Box
      component={href ? "a" : "button"}
      href={href}
      target={href ? "_blank" : undefined}
      rel={href ? "noopener noreferrer" : undefined}
      style={{
        padding: "10px 20px",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
        textAlign: "center",
        textDecoration: "none",
        display: "inline-block",
        alignSelf: "start",
        margin : margin,
        fontSize: fontSize, // Tamaño de fuente personalizado
        ...buttonStyles[type], // Aplica el tipo de botón
        ...style, // Permite sobrescribir estilos si es necesario
      }}
      onClick={href ? null : onClick}
    >
      {text}
    </Box>
  );
};

CustomButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  href: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.oneOf(["blue", "orange"]),
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};


export default CustomButton;
